(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-collapsible"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.about-collapsible-section').forEach(section => {
  const toggleBtn = section.querySelector('[data-ac-toggle]');
  const content = section.querySelector('[data-ac-content]');
  const labelEl = section.querySelector('[data-ac-button-label]');

  if (!toggleBtn || !content) return;

  const showLabel = toggleBtn.dataset.showLabel || 'Show more';
  const hideLabel = toggleBtn.dataset.hideLabel || 'Show less';

  // Sync the fade color to the box background so the gradient blends in
  const container = section.querySelector('.ac__container');
  if (container) {
    const bgColor = window.getComputedStyle(container).backgroundColor;
    content.style.setProperty('--ac-fade-color', bgColor);
  }

  // Hide the toggle if the content fits within the collapsed height (nothing to expand)
  const checkOverflow = () => {
    const collapsedHeight = parseInt(window.getComputedStyle(content).maxHeight);
    if (!isNaN(collapsedHeight) && content.scrollHeight <= collapsedHeight) {
      toggleBtn.style.display = 'none';
      content.removeAttribute('data-collapsed');
    }
  };

  checkOverflow();
  window.addEventListener('resize', checkOverflow);

  toggleBtn.addEventListener('click', () => {
    const isCollapsed = content.dataset.collapsed === 'true';

    if (isCollapsed) {
      // Expand
      content.style.maxHeight = content.scrollHeight + 'px';
      content.dataset.collapsed = 'false';
      content.setAttribute('aria-expanded', 'true');
      toggleBtn.setAttribute('aria-expanded', 'true');
      labelEl.textContent = hideLabel;

      // After transition, remove inline max-height so it stays open responsively
      const onTransitionEnd = () => {
        if (content.dataset.collapsed === 'false') {
          content.style.maxHeight = 'none';
        }
        content.removeEventListener('transitionend', onTransitionEnd);
      };
      content.addEventListener('transitionend', onTransitionEnd);
    } else {
      // Collapse
      // First set explicit height for transition to start from
      content.style.maxHeight = content.scrollHeight + 'px';

      // Force reflow so the transition picks up the change
      content.offsetHeight;

      // Then collapse
      requestAnimationFrame(() => {
        content.style.maxHeight = '';
        content.dataset.collapsed = 'true';
        content.setAttribute('aria-expanded', 'false');
        toggleBtn.setAttribute('aria-expanded', 'false');
        labelEl.textContent = showLabel;
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breadcrum-bar"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-announcement-close]').forEach(btn => {
  btn.addEventListener('click', () => {
    const bar = btn.closest('.announcement-bar');
    if (bar) {
      bar.style.display = 'none';
      try {
        sessionStorage.setItem('announcement-' + bar.id + '-closed', '1');
      } catch (e) {}
    }
  });
});

document.querySelectorAll('.announcement-bar').forEach(bar => {
  try {
    if (sessionStorage.getItem('announcement-' + bar.id + '-closed') === '1') {
      bar.style.display = 'none';
    }
  } catch (e) {}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-accessories-auto"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__cartAccAutoLoaded) return;
  window.__cartAccAutoLoaded = true;

  var FEED_SECTION = 'cart-accessories-auto'; // must match this file's name
  var MAX_PARALLEL = 6;
  var feedCache = {};

  function readConfig(root) {
    try { return JSON.parse(root.querySelector('[data-caa-config]').textContent); }
    catch (e) { return null; }
  }

  // "desk -chair" → search "desk", then drop titles containing "chair"
  function parseKeyword(keyword) {
    var parts = String(keyword).split(/\s+-/);
    return {
      word: parts[0].trim(),
      exclude: parts.slice(1).map(function (s) { return s.trim(); }).filter(Boolean)
    };
  }

  function fetchFeed(cfg, keyword) {
    keyword = parseKeyword(keyword).word;
    if (feedCache[keyword]) return feedCache[keyword];
    var q = keyword.indexOf(' ') !== -1 ? '"' + keyword + '"' : keyword;
    var url = cfg.searchUrl + '?q=' + encodeURIComponent(q) +
      '&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last' +
      '&section_id=' + FEED_SECTION;
    feedCache[keyword] = fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('[data-acc-card]'));
      })
      .catch(function () { return []; });
    return feedCache[keyword];
  }

  // Run fetches a few at a time so the store isn't flooded with requests
  function fetchAll(cfg, keywords) {
    var results = {}, i = 0;
    function worker() {
      if (i >= keywords.length) return Promise.resolve();
      var kw = keywords[i++];
      return fetchFeed(cfg, kw).then(function (cards) { results[kw] = cards; return worker(); });
    }
    var workers = [];
    for (var w = 0; w < Math.min(MAX_PARALLEL, keywords.length); w++) workers.push(worker());
    return Promise.all(workers).then(function () { return results; });
  }

  function titleMatches(card, word) {
    var title = card.dataset.title || '';
    // "table lamp" must appear as a phrase; single words match plurals too
    return title.indexOf(word) !== -1;
  }

  function titleExcluded(card, excludeWords) {
    var title = card.dataset.title || '';
    for (var i = 0; i < excludeWords.length; i++) {
      if (title.indexOf(excludeWords[i]) !== -1) return true;
    }
    return false;
  }

  function allowed(card, cfg, seen, keyword) {
    var id = card.dataset.productId;
    var kw = parseKeyword(keyword);
    if (seen[id]) return false;
    if (cfg.cartIds.indexOf(id) !== -1) return false;
    if (cfg.hideSoldOut && card.dataset.available !== 'true') return false;
    if (cfg.titleMustMatch && !titleMatches(card, kw.word)) return false;
    if (kw.exclude.length && titleExcluded(card, kw.exclude)) return false;
    return true;
  }

  function build(root) {
    var cfg = readConfig(root);
    if (!cfg) return;
    cfg.cartIds = (cfg.cartIds || []).filter(Boolean).map(String);
    var groups = (cfg.groups || []).filter(function (g) { return g && g.length; });

    if (!groups.length) { root.hidden = !cfg.designMode; return; }

    var unique = [];
    groups.forEach(function (g) { g.forEach(function (k) { if (unique.indexOf(k) === -1) unique.push(k); }); });

    fetchAll(cfg, unique).then(function (results) {
      var seen = {}, cards = [];
      var perKeyword = Math.max(1, cfg.perKeyword || 3);
      var maxRank = Math.max.apply(null, groups.map(function (g) { return g.length; }));

      // Pass 1: keyword order is priority. Rank 1 of every cart item, then rank 2 …
      // e.g. sofa → pillows first, then throws, then rugs.
      function pass(cap) {
        for (var r = 0; r < maxRank && cards.length < cfg.limit; r++) {
          for (var g = 0; g < groups.length && cards.length < cfg.limit; g++) {
            var kw = groups[g][r];
            if (!kw) continue;
            var list = results[kw] || [];
            var taken = 0;
            for (var c = 0; c < list.length && cards.length < cfg.limit; c++) {
              if (cap && taken >= cap) break;
              if (!allowed(list[c], cfg, seen, kw)) continue;
              seen[list[c].dataset.productId] = true;
              cards.push(list[c]);
              taken++;
            }
          }
        }
      }
      pass(perKeyword); // a few of each keyword, in priority order
      pass(0);          // then fill any empty slots in the same order

      var track = root.querySelector('[data-caa-track]');
      track.innerHTML = '';
      cards.forEach(function (c) {
        var clone = document.importNode(c, true);
        var btn = clone.querySelector('[data-acc-add]');
        if (btn && !btn.disabled && cfg.buttonLabel) btn.textContent = cfg.buttonLabel;
        track.appendChild(clone);
      });

      var note = root.querySelector('[data-caa-note]');
      if (note) note.hidden = cards.length > 0;
      root.hidden = cards.length === 0 && !cfg.designMode;
      var vp = root.querySelector('[data-caa-viewport]');
      if (vp) vp.scrollLeft = 0;
      updateArrows(root);
    });
  }

  function updateArrows(root) {
    var vp = root.querySelector('[data-caa-viewport]');
    var nav = root.querySelector('[data-caa-nav]');
    if (!vp || !nav) return;
    var max = vp.scrollWidth - vp.clientWidth - 2;
    nav.style.visibility = max <= 0 ? 'hidden' : '';
    root.querySelector('[data-caa-prev]').disabled = vp.scrollLeft <= 2;
    root.querySelector('[data-caa-next]').disabled = vp.scrollLeft >= max;
  }

  function stepSize(vp) {
    var card = vp.querySelector('.caa__card');
    if (!card) return vp.clientWidth;
    var gap = parseFloat(getComputedStyle(card.parentElement).columnGap) || 20;
    var perView = Math.max(1, Math.round(vp.clientWidth / (card.offsetWidth + gap)));
    return perView * (card.offsetWidth + gap);
  }

  function initAll() {
    document.querySelectorAll('[data-caa]').forEach(function (root) {
      if (root.__caaInit) return;
      root.__caaInit = true;
      var vp = root.querySelector('[data-caa-viewport]');
      vp.addEventListener('scroll', function () { updateArrows(root); }, { passive: true });
      build(root);
    });
  }

  // Re-render the section with the new cart, then rebuild the slider
  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.querySelectorAll('[data-caa]').forEach(function (root) {
        var cfg = readConfig(root);
        var id = root.dataset.sectionId;
        fetch((cfg ? cfg.cartUrl : '/cart') + '?section_id=' + encodeURIComponent(id))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.getElementById('caa-' + id);
            var current = document.getElementById('caa-' + id);
            if (fresh && current) { current.replaceWith(fresh); initAll(); }
          })
          .catch(function () {});
      });
    }, 250);
  }
  window.refreshCartAccessories = refresh;

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-caa-prev], [data-caa-next]');
    if (arrow) {
      var vp = arrow.closest('[data-caa]').querySelector('[data-caa-viewport]');
      vp.scrollBy({ left: (arrow.hasAttribute('data-caa-prev') ? -1 : 1) * stepSize(vp) });
      return;
    }

    var btn = e.target.closest('[data-caa] [data-acc-add]');
    if (!btn || btn.disabled) return;
    var root = btn.closest('[data-caa]');
    var cfg = readConfig(root) || {};
    var card = btn.closest('[data-acc-card]');
    var oldErr = card.querySelector('.caa__error');
    if (oldErr) oldErr.remove();

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch((cfg.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        btn.textContent = 'Added';
        if (cfg.afterAdd === 'reload') { window.location.reload(); return; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-accessories-auto' });
        }
        refresh();
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        var p = document.createElement('p');
        p.className = 'caa__error';
        p.textContent = (err && (err.description || err.message)) || 'Couldn’t add this item. Try again.';
        card.appendChild(p);
      });
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-caa] [data-acc-variant]');
    if (!sel) return;
    var card = sel.closest('[data-acc-card]');
    var opt = sel.options[sel.selectedIndex];
    card.querySelector('[data-acc-add]').dataset.variantId = opt.value;
    card.querySelector('[data-acc-price]').textContent = opt.dataset.price;
    var cmp = card.querySelector('[data-acc-compare]');
    cmp.textContent = opt.dataset.compare || '';
    cmp.hidden = !opt.dataset.compare;
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-caa]').forEach(updateArrows);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (evt && evt.source === 'cart-accessories-auto') return;
      refresh();
    });
  }
  ['cart:updated', 'cart:refresh', 'cart:change', 'theme:cart:change'].forEach(function (name) {
    document.addEventListener(name, refresh);
  });
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Bind once. Listeners live on `document`, so they keep working
  // after the Theme Editor re-renders the section.
  if (window.__cartPageBound) return;
  window.__cartPageBound = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function changeLine(payload) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart change failed (' + r.status + ')');
      return r.json();
    });
  }

  function setLoading(el) {
    var row = el.closest('.cart-item');
    if (row) row.classList.add('is-loading');
  }

  function submitForm(form) {
    if (!form) return;
    if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
    else { form.submit(); }
  }

  /* ---------- CLICK HANDLERS ---------- */
  document.addEventListener('click', function (e) {

    // Remove item -> /cart/change.js quantity 0 (falls back to item.url_to_remove)
    var removeBtn = e.target.closest('[data-remove-item]');
    if (removeBtn) {
      e.preventDefault();
      if (!confirm('Remove this item from your cart?')) return;

      var key = removeBtn.getAttribute('data-remove-item');
      var fallbackUrl = removeBtn.getAttribute('href');

      if (!key) {
        if (fallbackUrl) window.location.href = fallbackUrl;
        return;
      }

      setLoading(removeBtn);
      removeBtn.textContent = 'Removing...';

      changeLine({ id: key, quantity: 0 })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.href = fallbackUrl || (root + 'cart'); });
      return;
    }

    // Save item (visual hook -> wire to your wishlist app)
    var saveBtn = e.target.closest('[data-save-item]');
    if (saveBtn) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:save-item', {
        detail: { key: saveBtn.getAttribute('data-save-item') }
      }));
      alert('Saved! (Hook this to your wishlist app.)');
      return;
    }

    // Clear cart confirmation
    var clearBtn = e.target.closest('[data-clear-cart]');
    if (clearBtn) {
      if (!confirm('Are you sure you want to clear your cart?')) e.preventDefault();
      return;
    }

    // ZIP prompt
    var zipLink = e.target.closest('[data-zip-trigger]');
    if (zipLink) {
      e.preventDefault();
      var disp = zipLink.querySelector('[data-zip-display]');
      var current = disp ? disp.textContent : '';
      var newZip = prompt('Enter your ZIP code:', current);
      if (newZip && /^\d{5}$/.test(newZip)) {
        document.querySelectorAll('[data-zip-display]').forEach(function (el) { el.textContent = newZip; });
        try { localStorage.setItem('user_zip', newZip); } catch (err) {}
      }
    }
  });

  /* ---------- CHANGE HANDLERS ---------- */
  document.addEventListener('change', function (e) {

    // Quantity change -> /cart/change.js (falls back to form submit)
    var select = e.target.closest('[data-qty-select]');
    if (select) {
      var lineKey = select.getAttribute('data-line-key');
      var qty = parseInt(select.value, 10);
      if (!lineKey || isNaN(qty)) { submitForm(select.closest('form')); return; }

      setLoading(select);
      changeLine({ id: lineKey, quantity: qty })
        .then(function () { window.location.reload(); })
        .catch(function () { submitForm(select.closest('form')); });
      return;
    }

    // Protection plan toggle -> store as line item properties
    var checkbox = e.target.closest('[data-protection-toggle]');
    if (checkbox) {
      var planKey = checkbox.getAttribute('data-protection-toggle');
      var quantity = parseInt(checkbox.getAttribute('data-quantity'), 10) || 1;
      var props = checkbox.checked
        ? {
            '_protection_plan': checkbox.getAttribute('data-plan-name'),
            '_protection_plan_price': checkbox.getAttribute('data-plan-price')
          }
        : { '_protection_plan': '', '_protection_plan_price': '' };

      checkbox.disabled = true;
      setLoading(checkbox);
      changeLine({ id: planKey, quantity: quantity, properties: props })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }
  });

  /* ---------- LOAD SAVED ZIP ---------- */
  function loadZip() {
    try {
      var savedZip = localStorage.getItem('user_zip');
      if (savedZip) {
        document.querySelectorAll('[data-zip-display]').forEach(function (el) { el.textContent = savedZip; });
      }
    } catch (err) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadZip);
  } else {
    loadZip();
  }
  document.addEventListener('shopify:section:load', loadZip);
})();

/* =================== SALESPERSON SELECTOR =================== */
(function () {
  if (window.__cartSalespersonBound) return;
  window.__cartSalespersonBound = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var pending = null;
  var successTimer = null;

  function getSelect() { return document.querySelector('[data-salesperson-select]'); }

  function showMsg(type, show) {
    var el = document.querySelector('[data-salesperson-' + type + ']');
    if (el) el.hidden = !show;
  }

  function setInvalid(select, invalid) {
    var wrap = select.closest('[data-salesperson]');
    if (wrap) wrap.classList.toggle('is-invalid', invalid);
  }

  // Same as old validateSalesperson()
  function validateSalesperson() {
    var select = getSelect();
    if (!select) return true;
    var ok = !!select.value;
    showMsg('error', !ok);
    setInvalid(select, !ok);
    return ok;
  }

  // Same as old validateAndToggleCheckout()
  function validateAndToggleCheckout() {
    var select = getSelect();
    if (!select) return;
    var ok = !!select.value;
    document.querySelectorAll('[data-checkout-gate]').forEach(function (btn) {
      btn.classList.toggle('is-disabled', !ok);
      if (ok) { btn.removeAttribute('aria-disabled'); }
      else { btn.setAttribute('aria-disabled', 'true'); }
    });
  }

  // Same as old updateSalesperson(): saves the selection as cart attributes
  function updateSalesperson(select) {
    var selectedValue = select.value;

    if (!selectedValue) {
      showMsg('error', true);
      setInvalid(select, true);
      return;
    }
    showMsg('error', false);
    setInvalid(select, false);

    var attributes = { 'please-select-a-sales-person': selectedValue };
    if (selectedValue.indexOf(' - ') !== -1) {
      var parts = selectedValue.split(' - ');
      attributes['selected-showroom'] = parts[0];
      attributes['selected-salesperson'] = parts.slice(1).join(' - ');
    }

    var wrap = select.closest('[data-salesperson]');
    if (wrap) wrap.classList.add('is-saving');

    pending = fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart update failed (' + r.status + ')');
      showMsg('success', true);
      clearTimeout(successTimer);
      successTimer = setTimeout(function () { showMsg('success', false); }, 3000);
    }).catch(function () {
      // Leave checkout usable; the select keeps its value
    }).then(function () {
      if (wrap) wrap.classList.remove('is-saving');
      pending = null;
    });
  }

  /* ---------- CHANGE ---------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-salesperson-select]');
    if (!select) return;
    validateAndToggleCheckout();
    updateSalesperson(select);
  });

  /* ---------- CHECKOUT GATE ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-checkout-gate]');
    if (!btn) return;
    var select = getSelect();
    if (!select) return;

    if (!validateSalesperson()) {
      e.preventDefault();
      try { select.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
      select.focus({ preventScroll: true });
      return;
    }

    // Wait for the salesperson to finish saving before leaving the page
    if (pending) {
      e.preventDefault();
      var href = btn.getAttribute('href');
      pending.then(function () { window.location.href = href; });
    }
  });

  /* ---------- INIT ---------- */
  function init() { validateAndToggleCheckout(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-new"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-header]').forEach(function (header) {
    var drawer = header.querySelector('[data-drawer]');
    var overlay = header.querySelector('[data-drawer-overlay]');
    var openPanelBtns = header.querySelectorAll('[data-open-panel]');
    var backBtns = header.querySelectorAll('[data-back-to]');
    var closeBtns = header.querySelectorAll('[data-drawer-close]');
    var panels = header.querySelectorAll('[data-panel]');

    function showPanel(panelId) {
      panels.forEach(function (p) {
        if (p.dataset.panel === panelId) {
          p.classList.add('is-active');
          p.scrollTop = 0;
        } else {
          p.classList.remove('is-active');
        }
      });
    }

    function openDrawer(panelId) {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      showPanel(panelId || 'root');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Reset all panels
      setTimeout(function () {
        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });
      }, 300);
    }

    // Open buttons (burger + nav items + child items)
    openPanelBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var panelId = btn.dataset.openPanel;
        if (drawer.classList.contains('is-open')) {
          // Drawer already open — just switch panels
          showPanel(panelId);
        } else {
          // Drawer closed — open and show panel
          openDrawer(panelId);
        }
      });
    });

    // Back buttons
    backBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showPanel(btn.dataset.backTo);
      });
    });

    // Close buttons
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    // Overlay click
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider-new"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
    if (slides.length <= 1) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('.hero-slider__dot'));
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    var loop = root.dataset.loop === 'true';
    var current = 0;
    var timer = null;

    function goTo(index) {
      if (index >= slides.length) { if (!loop) return; index = 0; }
      if (index < 0) { if (!loop) return; index = slides.length - 1; }

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      current = index;
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function startAutoplay() { if (!autoplay) return; stopAutoplay(); timer = setInterval(next, interval); }
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.dot, 10);
        if (!isNaN(idx)) { goTo(idx); startAutoplay(); }
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    });

    var touchStartX = 0;
    root.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) >= 40) { if (diff > 0) next(); else prev(); }
      startAutoplay();
    }, { passive: true });

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.hero-slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    var triggers = acc.querySelectorAll('[data-acc-trigger]');
    var keepMultipleOpen = acc.dataset.multiple === 'true';

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.acc__item');
        var isOpen = item.classList.contains('is-open');

        // Close other items if "single open" mode
        if (!keepMultipleOpen && !isOpen) {
          acc.querySelectorAll('.acc__item.is-open').forEach(function (otherItem) {
            if (otherItem !== item) {
              otherItem.classList.remove('is-open');
              var otherTrigger = otherItem.querySelector('[data-acc-trigger]');
              if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            }
          });
        }

        // Toggle current item
        item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pdp-section').forEach(function (root) {
    var gallery = root.querySelector('[data-gallery]');

    if (gallery) {
      var mainSlides = gallery.querySelectorAll('[data-slide]');
      var thumbs = gallery.querySelectorAll('[data-thumb-target]');
      var videoIframe = gallery.querySelector('[data-video-iframe]');
      var modelViewer = gallery.querySelector('[data-model-viewer]');
      var closeButtons = gallery.querySelectorAll('[data-close-overlay]');
      var zoomWraps = gallery.querySelectorAll('[data-zoom-wrap]');

      zoomWraps.forEach(function (wrap) {
        var zoomImage = wrap.dataset.zoomImage;
        if (!zoomImage) return;

        var preloader = new Image();
        preloader.src = zoomImage;

        wrap.addEventListener('mouseenter', function () {
          wrap.style.backgroundImage = "url('" + zoomImage + "')";
          wrap.classList.add('is-zooming');
        });

        function clearZoom() {
          wrap.classList.remove('is-zooming');
          wrap.style.backgroundImage = '';
          wrap.style.backgroundPosition = '';
          wrap.style.backgroundColor = '';
        }

        wrap.addEventListener('mouseleave', clearZoom);
        wrap.addEventListener('blur', clearZoom);

        wrap.addEventListener('mousemove', function (e) {
          var rect = wrap.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          x = Math.max(0, Math.min(100, x));
          y = Math.max(0, Math.min(100, y));
          wrap.style.backgroundPosition = x + '% ' + y + '%';
        });
      });

      var thumbsTrack = gallery.querySelector('[data-thumbs-track]');
      var thumbsViewport = gallery.querySelector('[data-thumbs-viewport]');
      var thumbPrev = gallery.querySelector('[data-thumb-prev]');
      var thumbNext = gallery.querySelector('[data-thumb-next]');
      var thumbScrollPos = 0;

      function thumbStep() {
        var first = thumbsTrack.querySelector('.gal__thumb');
        if (!first) return 80;
        var w = first.offsetWidth;
        var gap = 8;
        return w + gap;
      }

      function updateThumbsCarousel() {
        if (!thumbsTrack || !thumbsViewport) return;
        var trackWidth = thumbsTrack.scrollWidth;
        var viewportWidth = thumbsViewport.offsetWidth;
        var maxScroll = Math.max(0, trackWidth - viewportWidth);

        if (thumbScrollPos > maxScroll) thumbScrollPos = maxScroll;
        if (thumbScrollPos < 0) thumbScrollPos = 0;

        thumbsTrack.style.transform = 'translateX(-' + thumbScrollPos + 'px)';

        if (thumbPrev) thumbPrev.disabled = thumbScrollPos <= 0;
        if (thumbNext) thumbNext.disabled = thumbScrollPos >= maxScroll;

        var hasOverflow = trackWidth > viewportWidth;
        if (thumbPrev) thumbPrev.style.display = hasOverflow ? '' : 'none';
        if (thumbNext) thumbNext.style.display = hasOverflow ? '' : 'none';
      }

      if (thumbPrev) {
        thumbPrev.addEventListener('click', function () {
          thumbScrollPos -= thumbStep() * 3;
          updateThumbsCarousel();
        });
      }
      if (thumbNext) {
        thumbNext.addEventListener('click', function () {
          thumbScrollPos += thumbStep() * 3;
          updateThumbsCarousel();
        });
      }

      window.addEventListener('resize', updateThumbsCarousel);
      setTimeout(updateThumbsCarousel, 50);

      function activateSlide(target) {
        mainSlides.forEach(function (s) {
          s.classList.toggle('is-active', s.dataset.slide === target);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.dataset.thumbTarget === target);
        });

        if (target === 'video' && videoIframe) {
          var key = (videoIframe.dataset.youtubeKey || '').trim();
          var currentSrc = videoIframe.getAttribute('src') || '';
          if (key && currentSrc.indexOf('youtube.com/embed/') === -1) {
            videoIframe.setAttribute('src', 'https://www.youtube.com/embed/' + key + '?autoplay=1&rel=0&playsinline=1');
          }
        } else if (videoIframe) {
          var currentSrc2 = videoIframe.getAttribute('src') || '';
          if (currentSrc2.indexOf('youtube.com/embed/') !== -1) {
            videoIframe.setAttribute('src', '');
          }
        }

        if (target === 'model' && modelViewer) {
          var glbSrc = (modelViewer.dataset.glbSrc || '').trim();
          var currentGlb = modelViewer.getAttribute('src') || '';
          if (glbSrc && currentGlb === '') {
            modelViewer.setAttribute('src', glbSrc);
          }
        }
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateSlide(thumb.dataset.thumbTarget);
        });
      });

      closeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () { activateSlide('0'); });
      });
    }

    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyDec = root.querySelector('[data-qty-decrement]');
    var qtyInc = root.querySelector('[data-qty-increment]');

    function updateSubtotal() {
      var priceEl = root.querySelector('[data-product-price]');
      var subtotalEl = root.querySelector('[data-subtotal]');
      if (!priceEl || !subtotalEl || !qtyInput) return;
      var qty = parseInt(qtyInput.value, 10) || 1;
      var priceText = priceEl.textContent.replace(/[^0-9.,]/g, '').replace(',', '');
      var price = parseFloat(priceText) || 0;
      var total = (price * qty).toFixed(2);
      var prefix = priceEl.textContent.match(/^[^\d]+/);
      subtotalEl.textContent = (prefix ? prefix[0] : '$') + total;
    }

    if (qtyInput && qtyDec && qtyInc) {
      qtyDec.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
        updateSubtotal();
      });
      qtyInc.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
        updateSubtotal();
      });
      qtyInput.addEventListener('change', updateSubtotal);
    }

    var optionBtns = root.querySelectorAll('[data-option-position]');
    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.dataset.optionPosition;
        var siblings = root.querySelectorAll('[data-option-position="' + pos + '"]');
        siblings.forEach(function (sib) {
          sib.classList.toggle('is-selected', sib === btn);
        });
        var selectedSpan = root.querySelector('[data-option-selected="' + pos + '"]');
        if (selectedSpan) selectedSpan.textContent = btn.dataset.optionValue;
      });
    });

    var wishlistBtn = root.querySelector('[data-wishlist-btn]');
    if (wishlistBtn) {
      wishlistBtn.addEventListener('click', function () {
        wishlistBtn.classList.toggle('is-active');
      });
    }

    var accContainer = root.querySelector('[data-pdp-accordion]');
    if (accContainer) {
      var accTriggers = accContainer.querySelectorAll('[data-acc-trigger]');
      var keepMultipleOpen = accContainer.dataset.multiple === 'true';

      accTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var item = trigger.closest('.pdp-acc__item');
          var isOpen = item.classList.contains('is-open');

          if (!keepMultipleOpen && !isOpen) {
            accContainer.querySelectorAll('.pdp-acc__item.is-open').forEach(function (other) {
              if (other !== item) {
                other.classList.remove('is-open');
                var otherTrigger = other.querySelector('[data-acc-trigger]');
                if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
              }
            });
          }

          item.classList.toggle('is-open');
          trigger.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
        });
      });
    }
  });

  function openModal(modalId) {
    var modal = document.querySelector('[data-modal="' + modalId + '"]');
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeAllModals() {
    document.querySelectorAll('.pdp-modal.is-open').forEach(function (m) {
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-open-modal]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openModal(btn.dataset.openModal);
    });
  });

  document.querySelectorAll('[data-modal-close]').forEach(function (btn) {
    btn.addEventListener('click', closeAllModals);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllModals();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-recently-viewed]').forEach(function (section) {
    var storageKey = section.dataset.storageKey || 'recently_viewed_products';
    var maxProducts = parseInt(section.dataset.maxProducts, 10) || 10;
    var currentHandle = section.dataset.currentProductHandle || '';
    var exclusiveTag = (section.dataset.exclusiveTag || '').toLowerCase();
    var exclusiveLabel = section.dataset.exclusiveLabel || 'ASHLEY EXCLUSIVE';
    var carousel = section.querySelector('[data-rv-carousel]');
    var track = section.querySelector('[data-track]');
    var loading = section.querySelector('[data-loading]');
    var prevBtn = section.querySelector('[data-prev]');
    var nextBtn = section.querySelector('[data-next]');
    var viewport = section.querySelector('[data-viewport]');
    var template = document.querySelector('[data-rv-card-template]');

    if (!track || !template) return;

    // ===== Track the current product in localStorage =====
    function getStored() {
      try {
        var raw = localStorage.getItem(storageKey);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return [];
      }
    }

    function saveStored(handles) {
      try {
        localStorage.setItem(storageKey, JSON.stringify(handles));
      } catch (e) {
        // localStorage may be unavailable in private mode
      }
    }

    function trackCurrent() {
      if (!currentHandle) return;
      var stored = getStored();
      // Remove current if already present, then prepend
      stored = stored.filter(function (h) { return h !== currentHandle; });
      stored.unshift(currentHandle);
      // Cap at maxProducts + 1 (so we still have N other products after excluding current)
      stored = stored.slice(0, maxProducts + 1);
      saveStored(stored);
    }

    trackCurrent();

    // ===== Get handles to display (exclude current) =====
    var handlesToShow = getStored().filter(function (h) {
      return h !== currentHandle;
    }).slice(0, maxProducts);

    if (handlesToShow.length === 0) {
      section.classList.add('is-empty');
      return;
    }

    // ===== Fetch each product as JSON =====
    function fetchProduct(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('Not found');
          return r.json();
        })
        .catch(function () { return null; });
    }

    function moneyFormat(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    function buildStarsHTML(rating) {
      var html = '';
      var fullStars = Math.floor(rating);
      var hasHalf = (rating - fullStars) >= 0.5;
      for (var i = 1; i <= 5; i++) {
        if (i <= fullStars) {
          html += '<span class="rv__star"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg></span>';
        } else if (hasHalf && i === fullStars + 1) {
          html += '<span class="rv__star"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14"><defs><linearGradient id="half-star-' + Math.random().toString(36).substr(2, 9) + '"><stop offset="50%" stop-color="currentColor"/><stop offset="50%" stop-color="#e0e0e0"/></linearGradient></defs><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="currentColor" fill-opacity="0.5"/><polygon points="12 2 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="currentColor"/></svg></span>';
        } else {
          html += '<span class="rv__star" style="color: #e0e0e0;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg></span>';
        }
      }
      return html;
    }

    function buildSwatches(product) {
      var swatchHTML = '';
      var maxSwatches = 4;

      // Find color option
      var colorOptionIndex = -1;
      var colorOptionValues = [];
      if (product.options && product.options.length > 0) {
        for (var i = 0; i < product.options.length; i++) {
          var optName = (typeof product.options[i] === 'string' ? product.options[i] : product.options[i].name || '').toLowerCase();
          if (optName.indexOf('color') !== -1 || optName.indexOf('colour') !== -1 || optName.indexOf('finish') !== -1) {
            colorOptionIndex = i;
            break;
          }
        }
      }

      if (colorOptionIndex < 0 || !product.variants) return '';

      // Collect unique color values from variants
      var seenColors = {};
      product.variants.forEach(function (v) {
        var colorValue = v['option' + (colorOptionIndex + 1)];
        if (colorValue && !seenColors[colorValue]) {
          seenColors[colorValue] = true;
          colorOptionValues.push({ value: colorValue, image: v.featured_image });
        }
      });

      if (colorOptionValues.length === 0) return '';

      var visibleSwatches = colorOptionValues.slice(0, maxSwatches);
      var moreCount = colorOptionValues.length - maxSwatches;

      visibleSwatches.forEach(function (c, idx) {
        var colorSlug = c.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        var isSelected = idx === 0 ? ' is-selected' : '';
        swatchHTML += '<button type="button" class="rv__swatch' + isSelected + '" aria-label="' + c.value + '" title="' + c.value + '" style="background-color: ' + colorSlug + ';"></button>';
      });

      if (moreCount > 0) {
        swatchHTML += '<a href="/products/' + product.handle + '" class="rv__swatch-more">' + moreCount + '+</a>';
      }

      return swatchHTML;
    }

    function renderProduct(product) {
      if (!product) return null;

      var clone = template.content.cloneNode(true);
      var card = clone.querySelector('[data-card]');
      var url = '/products/' + product.handle;

      // Image
      var imageLink = clone.querySelector('[data-card-link]');
      var image = clone.querySelector('[data-card-image]');
      imageLink.href = url;
      if (product.featured_image) {
        image.src = product.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_600x$1$2');
        image.alt = product.title;
      } else if (product.images && product.images.length > 0) {
        image.src = product.images[0].replace(/(\.[a-z]+)(\?.*)?$/i, '_600x$1$2');
        image.alt = product.title;
      } else {
        image.style.display = 'none';
      }

      // Swatches
      var swatchesContainer = clone.querySelector('[data-card-swatches]');
      swatchesContainer.innerHTML = buildSwatches(product);

      // Wire swatch hover image swap
      var allSwatches = swatchesContainer.querySelectorAll('.rv__swatch');
      allSwatches.forEach(function (sw, idx) {
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          allSwatches.forEach(function (other) { other.classList.toggle('is-selected', other === sw); });
        });
      });

      // Title
      var titleLink = clone.querySelector('[data-card-title-link]');
      titleLink.href = url;
      titleLink.textContent = product.title;

      // Exclusive badge — check tags
      if (product.tags && product.tags.length > 0) {
        var hasTag = product.tags.some(function (t) {
          return t.toLowerCase() === exclusiveTag;
        });
        if (hasTag) {
          var badge = clone.querySelector('[data-card-exclusive]');
          badge.textContent = exclusiveLabel;
          badge.hidden = false;
        }
      }

      // Rating from metafields (if available in product JSON via app)
      // product.js doesn't expose metafields directly — would need a metafields fetch.
      // For now, hide the rating block. Replace with your review app's data source.
      var ratingBlock = clone.querySelector('[data-card-rating]');
      // Try to read from product.metafields if exposed by a custom endpoint
      if (product._rating && product._review_count) {
        ratingBlock.hidden = false;
        clone.querySelector('[data-card-stars]').innerHTML = buildStarsHTML(product._rating);
        clone.querySelector('[data-card-review-count]').textContent = '(' + product._review_count + ')';
      }

      // Price
      var price = clone.querySelector('[data-card-price]');
      var comparePrice = clone.querySelector('[data-card-compare-price]');
      price.textContent = moneyFormat(product.price);
      if (product.compare_at_price && product.compare_at_price > product.price) {
        comparePrice.textContent = moneyFormat(product.compare_at_price);
        comparePrice.hidden = false;
      }

      return card;
    }

    // ===== Fetch all products in parallel =====
    Promise.all(handlesToShow.map(fetchProduct))
      .then(function (products) {
        var validProducts = products.filter(Boolean);

        if (validProducts.length === 0) {
          section.classList.add('is-empty');
          return;
        }

        if (loading) loading.remove();

        validProducts.forEach(function (p) {
          var card = renderProduct(p);
          if (card) track.appendChild(card);
        });

        initCarousel();
      })
      .catch(function () {
        section.classList.add('is-empty');
      });

    // ===== Carousel logic =====
    function initCarousel() {
      var cards = track.querySelectorAll('[data-card]');
      if (cards.length === 0) {
        section.classList.add('is-empty');
        return;
      }

      var currentIndex = 0;

      function getCardsPerView() {
        var width = window.innerWidth;
        if (width <= 420) return 1;
        if (width <= 600) return 2;
        if (width <= 900) return 3;
        if (width <= 1100) return 4;
        return parseInt(section.dataset.cardsPerView, 10) || 5;
      }

      function update() {
        var perView = getCardsPerView();
        var maxIndex = Math.max(0, cards.length - perView);
        if (currentIndex > maxIndex) currentIndex = maxIndex;
        if (currentIndex < 0) currentIndex = 0;

        var cardWidth = cards[0].offsetWidth;
        var gapStyle = window.getComputedStyle(track).gap || '24px';
        var gap = parseFloat(gapStyle) || 24;
        var offset = currentIndex * (cardWidth + gap);
        track.style.transform = 'translateX(-' + offset + 'px)';

        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          if (currentIndex > 0) { currentIndex--; update(); }
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var perView = getCardsPerView();
          var maxIndex = Math.max(0, cards.length - perView);
          if (currentIndex < maxIndex) { currentIndex++; update(); }
        });
      }

      // Touch / swipe
      var startX = 0, deltaX = 0, isDragging = false;
      viewport.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        isDragging = true;
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (!isDragging) return;
        deltaX = e.touches[0].clientX - startX;
      }, { passive: true });
      viewport.addEventListener('touchend', function () {
        if (!isDragging) return;
        isDragging = false;
        if (Math.abs(deltaX) > 50) {
          if (deltaX < 0 && nextBtn) nextBtn.click();
          else if (deltaX > 0 && prevBtn) prevBtn.click();
        }
        deltaX = 0;
      });

      window.addEventListener('resize', update);
      update();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-series-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-track]');
    var viewport = carousel.querySelector('[data-viewport]');
    var cards = carousel.querySelectorAll('[data-card]');
    var prevBtn = carousel.querySelector('[data-prev]');
    var nextBtn = carousel.querySelector('[data-next]');

    if (!track || cards.length === 0) return;

    var currentIndex = 0;

    function getCardsPerView() {
      var width = window.innerWidth;
      if (width <= 480) return 1;
      if (width <= 768) return 2;
      if (width <= 990) return 3;
      return parseInt(carousel.dataset.cardsPerView, 10) || 4;
    }

    function update() {
      var maxTranslate = Math.max(0, track.scrollWidth - viewport.clientWidth);
      if (currentIndex > cards.length - 1) currentIndex = cards.length - 1;

      var firstOffset = cards[0].offsetLeft;
      var offset = cards[currentIndex] ? cards[currentIndex].offsetLeft - firstOffset : 0;
      if (offset > maxTranslate) offset = maxTranslate;

      track.style.transform = 'translateX(-' + offset + 'px)';

      prevBtn.disabled = offset <= 0;
      nextBtn.disabled = offset >= (maxTranslate - 1);
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; update(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < cards.length - 1) { currentIndex++; update(); }
    });

    // Touch / drag support
    var startX = 0;
    var deltaX = 0;
    var isDragging = false;

    function onDragStart(clientX) {
      startX = clientX;
      deltaX = 0;
      isDragging = true;
    }

    function onDragMove(clientX) {
      if (!isDragging) return;
      deltaX = clientX - startX;
    }

    function onDragEnd() {
      if (!isDragging) return;
      isDragging = false;
      if (Math.abs(deltaX) > 50) {
        if (deltaX < 0) nextBtn.click();
        else prevBtn.click();
      }
      deltaX = 0;
    }

    viewport.addEventListener('touchstart', function (e) {
      onDragStart(e.touches[0].clientX);
    }, { passive: true });

    viewport.addEventListener('touchmove', function (e) {
      onDragMove(e.touches[0].clientX);
    }, { passive: true });

    viewport.addEventListener('touchend', onDragEnd);
    viewport.addEventListener('mousedown', function (e) { onDragStart(e.clientX); });
    viewport.addEventListener('mousemove', function (e) { onDragMove(e.clientX); });
    viewport.addEventListener('mouseleave', onDragEnd);
    viewport.addEventListener('mouseup', onDragEnd);

    window.addEventListener('resize', update);
    update();

    // Variant option switching per card
    cards.forEach(function (card) {
      var variantInput = card.querySelector('[data-card-variant-id]');
      var variantsScript = card.querySelector('[data-card-variants]');
      var optionBtns = card.querySelectorAll('[data-option-position]');
      var addBtn = card.querySelector('.sc__add-btn');

      if (!variantsScript) return;

      var variants;
      try { variants = JSON.parse(variantsScript.textContent); }
      catch (e) { variants = []; }

      var selectedOptions = {};
      card.querySelectorAll('.sc__option-value.is-selected').forEach(function (btn) {
        selectedOptions[btn.dataset.optionPosition] = btn.dataset.optionValue;
      });

      function findVariant() {
        return variants.find(function (v) {
          var options = [v.option1, v.option2, v.option3];
          for (var pos in selectedOptions) {
            if (options[parseInt(pos, 10)] !== selectedOptions[pos]) return false;
          }
          return true;
        });
      }

      optionBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = btn.dataset.optionPosition;
          card.querySelectorAll('[data-option-position="' + pos + '"]').forEach(function (sib) {
            sib.classList.toggle('is-selected', sib === btn);
          });
          var displaySpan = card.querySelector('[data-option-display="' + pos + '"]');
          if (displaySpan) displaySpan.textContent = btn.dataset.optionValue;

          selectedOptions[pos] = btn.dataset.optionValue;

          var newVariant = findVariant();
          if (newVariant && variantInput) {
            variantInput.value = newVariant.id;
            if (addBtn) {
              if (newVariant.available) {
                addBtn.disabled = false;
                addBtn.textContent = addBtn.dataset.addLabel || addBtn.textContent.trim();
              } else {
                addBtn.disabled = true;
                addBtn.textContent = 'Sold Out';
              }
            }
          }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-category-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTabbedCollections(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    var tabs       = section.querySelectorAll('.tabbed-collections__nav-item');
    var panels     = section.querySelectorAll('.tabbed-collections__panel');
    var accHeaders = section.querySelectorAll('.tabbed-collections__accordion-header');

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    // ===== DESKTOP: switch tabs =====
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (isMobile()) return;
        var target = tab.getAttribute('data-tab-target');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
        });

        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');

        var panel = section.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });

      // Arrow-key navigation
      tab.addEventListener('keydown', function (e) {
        var arr = Array.prototype.slice.call(tabs);
        var idx = arr.indexOf(tab);
        var nextIdx = null;
        if (e.key === 'ArrowRight') nextIdx = (idx + 1) % arr.length;
        if (e.key === 'ArrowLeft')  nextIdx = (idx - 1 + arr.length) % arr.length;
        if (nextIdx !== null) {
          e.preventDefault();
          arr[nextIdx].focus();
          arr[nextIdx].click();
        }
      });
    });

    // ===== MOBILE: accordion toggle =====
    accHeaders.forEach(function (header) {
      header.addEventListener('click', function () {
        if (!isMobile()) return;
        var target = header.getAttribute('data-accordion-target');
        var panel  = section.querySelector('[data-panel="' + target + '"]');
        if (!panel) return;

        var isOpen = panel.classList.contains('is-active');
        if (isOpen) {
          panel.classList.remove('is-active');
          header.classList.remove('is-active');
          header.setAttribute('aria-expanded', 'false');
        } else {
          panel.classList.add('is-active');
          header.classList.add('is-active');
          header.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // ===== Sync desktop ↔ mobile state on resize =====
    var mqMobile = window.matchMedia('(max-width: 749px)');

    function syncOnBreakpointChange(e) {
      if (e.matches) {
        var anyActive = false;
        panels.forEach(function (p) {
          var header = p.querySelector('.tabbed-collections__accordion-header');
          if (p.classList.contains('is-active')) {
            if (header) {
              header.classList.add('is-active');
              header.setAttribute('aria-expanded', 'true');
            }
            anyActive = true;
          } else if (header) {
            header.classList.remove('is-active');
            header.setAttribute('aria-expanded', 'false');
          }
        });
        if (!anyActive && panels.length) {
          panels[0].classList.add('is-active');
          var firstHeader = panels[0].querySelector('.tabbed-collections__accordion-header');
          if (firstHeader) {
            firstHeader.classList.add('is-active');
            firstHeader.setAttribute('aria-expanded', 'true');
          }
        }
      } else {
        var firstActive = section.querySelector('.tabbed-collections__panel.is-active');
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        if (firstActive) {
          firstActive.classList.add('is-active');
        } else if (panels.length) {
          panels[0].classList.add('is-active');
        }

        var activePanelId = section.querySelector('.tabbed-collections__panel.is-active');
        if (activePanelId) {
          var panelId = activePanelId.getAttribute('data-panel');
          tabs.forEach(function (t) {
            var isMatch = t.getAttribute('data-tab-target') === panelId;
            t.classList.toggle('is-active', isMatch);
            t.setAttribute('aria-selected', isMatch ? 'true' : 'false');
            t.setAttribute('tabindex', isMatch ? '0' : '-1');
          });
        }
      }
    }

    if (mqMobile.addEventListener) {
      mqMobile.addEventListener('change', syncOnBreakpointChange);
    } else if (mqMobile.addListener) {
      mqMobile.addListener(syncOnBreakpointChange);
    }
  }

  document.querySelectorAll('[data-section-type="tabbed-collections"]').forEach(initTabbedCollections);

  document.addEventListener('shopify:section:load', function (event) {
    var sec = event.target.querySelector('[data-section-type="tabbed-collections"]');
    if (sec) initTabbedCollections(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-may-also-like"] && !Shopify.designMode) return;
  try {
    
(function () {
  var relatedFetchControllers = new WeakMap();

  function initRelatedCarousel(carousel) {
    if (!carousel || carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';

    var track = carousel.querySelector('[data-track]');
    var viewport = carousel.querySelector('[data-viewport]');
    var cards = carousel.querySelectorAll('[data-card]');
    var prevBtn = carousel.querySelector('[data-prev]');
    var nextBtn = carousel.querySelector('[data-next]');

    if (!track || cards.length === 0) return;

    var currentIndex = 0;

    function getCardsPerView() {
      var width = window.innerWidth;
      var mobile = parseInt(carousel.dataset.cardsPerViewMobile, 10) || 2;
      if (width <= 600) return mobile;       // covers the 420px + 600px range
      if (width <= 900) return 3;
      if (width <= 1100) return 4;
      return parseInt(carousel.dataset.cardsPerView, 10) || 5;
    }

    function update() {
      var perView = getCardsPerView();
      var maxIndex = Math.max(0, cards.length - perView);
      if (currentIndex > maxIndex) currentIndex = maxIndex;
      if (currentIndex < 0) currentIndex = 0;

      var cardWidth = cards[0].offsetWidth;
      var gapStyle = window.getComputedStyle(track).gap || '24px';
      var gap = parseFloat(gapStyle) || 24;
      var offset = currentIndex * (cardWidth + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';

      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentIndex > 0) { currentIndex--; update(); }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var perView = getCardsPerView();
        var maxIndex = Math.max(0, cards.length - perView);
        if (currentIndex < maxIndex) { currentIndex++; update(); }
      });
    }

    // Touch / swipe
    var startX = 0;
    var deltaX = 0;
    var isDragging = false;

    if (viewport) {
      viewport.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        isDragging = true;
      }, { passive: true });

      viewport.addEventListener('touchmove', function (e) {
        if (!isDragging) return;
        deltaX = e.touches[0].clientX - startX;
      }, { passive: true });

      viewport.addEventListener('touchend', function () {
        if (!isDragging) return;
        isDragging = false;
        if (Math.abs(deltaX) > 50) {
          if (deltaX < 0 && nextBtn) nextBtn.click();
          else if (deltaX > 0 && prevBtn) prevBtn.click();
        }
        deltaX = 0;
      });
    }

    window.addEventListener('resize', update);
    update();

    // ===== Swatch hover/click → swap product image =====
    cards.forEach(function (card) {
      var swatches = card.querySelectorAll('[data-swatch-value]');
      var image = card.querySelector('.rc__image');
      var originalSrc = image ? image.src : '';

      swatches.forEach(function (swatch) {
        swatch.addEventListener('mouseenter', function () {
          var newSrc = swatch.dataset.swatchImage;
          if (newSrc && image) image.src = newSrc;
        });

        swatch.addEventListener('mouseleave', function () {
          // Restore to currently-selected swatch's image, or original
          var selected = card.querySelector('.rc__swatch.is-selected');
          if (selected && selected.dataset.swatchImage) {
            image.src = selected.dataset.swatchImage;
          } else if (image) {
            image.src = originalSrc;
          }
        });

        swatch.addEventListener('click', function () {
          card.querySelectorAll('.rc__swatch').forEach(function (sw) {
            sw.classList.toggle('is-selected', sw === swatch);
          });
          if (swatch.dataset.swatchImage && image) {
            originalSrc = swatch.dataset.swatchImage;
            image.src = swatch.dataset.swatchImage;
          }
        });
      });
    });

    // ===== Wishlist toggle (visual only — hook to your wishlist app) =====
    carousel.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('is-active');
      });
    });
  }

  function loadShopifyRelated(sectionEl, options) {
    options = options || {};

    if (!sectionEl || sectionEl.dataset.fetching === 'true') return;
    if (sectionEl.dataset.productSource !== 'recommendations' && sectionEl.dataset.productSource !== 'related') return;
    if (!options.force && sectionEl.dataset.needsFetch !== 'true') return;

    var productId = sectionEl.dataset.productId;
    if (!productId) return;

    var activeController = relatedFetchControllers.get(sectionEl);
    if (activeController) activeController.abort();

    var abortController = new AbortController();
    relatedFetchControllers.set(sectionEl, abortController);

    sectionEl.dataset.fetching = 'true';

    function buildRecommendationUrl() {
      var existingUrl = sectionEl.dataset.url;
      if (existingUrl) {
        var absolute = new URL(existingUrl, window.location.origin);
        absolute.searchParams.set('product_id', productId);
        absolute.searchParams.set('intent', sectionEl.dataset.intent || 'related');
        absolute.searchParams.set('limit', sectionEl.dataset.limit || '10');
        return absolute.toString();
      }

      var sectionInstanceId = '';
      if (sectionEl.id && sectionEl.id.indexOf('related-carousel-') === 0) {
        sectionInstanceId = sectionEl.id.replace('related-carousel-', '');
      }

      var params = new URLSearchParams({
        section_id: sectionInstanceId || sectionEl.dataset.sectionHandle || '',
        product_id: productId,
        intent: sectionEl.dataset.intent || 'related',
        limit: sectionEl.dataset.limit || '10'
      });

      return '{{ routes.product_recommendations_url }}?' + params.toString();
    }

    function fetchRelatedOnce() {
      var url = buildRecommendationUrl();

      return fetch(url, { signal: abortController.signal })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var fetchedSection =
            wrapper.querySelector('[data-related-section]') ||
            wrapper.querySelector('.related-carousel-section');
          if (!fetchedSection) return false;

          var fetchedCarousel = fetchedSection.querySelector('[data-related-carousel]');
          var fetchedCards = fetchedCarousel ? fetchedCarousel.querySelectorAll('[data-card]') : [];
          if (!fetchedCards.length) return false;

          fetchedSection.dataset.needsFetch = 'false';
          sectionEl.replaceWith(fetchedSection);
          initRelatedInRoot(fetchedSection);
          return true;
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return false;
          return false;
        })
        .then(function (loaded) {
          return loaded;
        });
    }

    fetchRelatedOnce()
      .finally(function () {
        sectionEl.dataset.fetching = 'false';
      });
  }

  function initRelatedInRoot(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('[data-related-carousel]').forEach(function (carousel) {
      initRelatedCarousel(carousel);
    });

    root.querySelectorAll('[data-related-section]').forEach(function (sectionEl) {
      loadShopifyRelated(sectionEl);
    });
  }

  initRelatedInRoot(document);

  if (!window.__youMayLikeEditorEventsBound) {
    window.__youMayLikeEditorEventsBound = true;

    document.addEventListener('shopify:section:load', function (event) {
      initRelatedInRoot(event.target || document);
    });

    document.addEventListener('shopify:section:select', function (event) {
      initRelatedInRoot(event.target || document);
    });
  }

  if (
    !window.__youMayLikeVariantEventsBound &&
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange
  ) {
    window.__youMayLikeVariantEventsBound = true;

    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      document.querySelectorAll('[data-related-section]').forEach(function (sectionEl) {
        sectionEl.dataset.needsFetch = 'true';
        loadShopifyRelated(sectionEl, { force: true });
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
